import { render } from "./InDevelopment.vue?vue&type=template&id=06c1fa24&scoped=true"
const script = {}

import "./InDevelopment.vue?vue&type=style&index=0&id=06c1fa24&scoped=true&lang=scss"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c1fa24"]])

export default __exports__